import $ from 'jquery';
import * as Sqrl from 'squirrelly';
import {formatMoney} from '@shopify/theme-currency';
import {getSizedImageUrl} from '@shopify/theme-images';

const selectors = {
  addDrawerWrapper: '[data-product-add-popdown-wrapper]',
  addDrawerTemplate: '[data-product-add-popdown-template]',
};

var $drawer = $(selectors.addDrawerWrapper);
var source = $(selectors.addDrawerTemplate).html();
var template = {};
var globalTimer;

function largePopdown(form_data) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: form_data,
    error: addError,
    success: addSuccess,
    complete: updateHeaderTotal,
  });
}

var updateHeaderTotal = function() {
  window.fetch('/cart.js')
    .then(handleErrors)
    .then(response => {
      return response.json();
    })
    .then(response => {
      document.dispatchEvent(new CustomEvent('theme:cart:change', {
        detail: {
          cart: response,
        },
        bubbles: true,
      }));
    })
    .catch(e => {
      console.error(e);
    });
};
function handleErrors(response) {
  if (!response.ok) {
    return response.json().then(function(json) {
      const e = new FetchError({
        status: response.statusText,
        headers: response.headers,
        json: json,
      });
      throw e;
    });
  }
  return response;
}
function FetchError(object) {
  this.status = object.status || null;
  this.headers = object.headers || null;
  this.json = object.json || null;
  this.body = object.body || null;
}
FetchError.prototype = Error.prototype;


var addError = function(object) {
  var errors = '<div class="errors">' + object.responseJSON.description + '</div>';
  $drawer.empty();
  $drawer.append(errors);
  $drawer.addClass('has-errors is-visible');
  popdown();
};
var addSuccess = function(variant) {
  var image = getSizedImageUrl(variant.image, '360x360');
  var productObject = {
    product_title: variant.product_title,
    product_image: image,
    quantity: variant.quantity,
    price: formatMoney(variant.price, theme.moneyFormat),
  };
  $drawer.empty();
  template = Sqrl.render(source, productObject);
  $drawer.append(template);

  // Popover should be just below header
  var minHeight = $('[data-header-wrapper').outerHeight() + $('[data-announcement-wrapper]').outerHeight();
  $drawer.attr('style', '');
  $drawer.css('min-height', minHeight);

  $drawer.addClass('is-visible');
  popdown();
};
var popdown = function() {
  clearTimeout(globalTimer);
  globalTimer = setTimeout(() => {
    $drawer.removeClass('is-visible').removeClass('has-errors');
  }, 5000);
};
$drawer.on('click', '[data-close-popdown]', () => {
  $drawer.removeClass('is-visible').removeClass('has-errors');
});

export {largePopdown as default};
